import withAuthHeader from '../../utils/withAuthHeader'
import checkAuthorizationError from '../../utils/checkAuthorizationError';
import { mapFetchStoreInformationResponse, mapFetchStoreMultistoreResponse } from '../mappers/store'

export const actionTypes = {
    SET_STORE_INFORMATION: 'SET_STORE_INFORMATION'
}

export const fetchStoreInformation = () => async (dispatch, getState, api) => {
    let result = {}
    try {
        const url = `api/v1/dashboard/estabelecimentos`;
        const apiResponse = await api.get(url, {
            ...withAuthHeader()
        });
        const response = mapFetchStoreInformationResponse(apiResponse.data);
        result = {
            success: true,
            data: response
        }
        dispatch({
            type: actionTypes.SET_STORE_INFORMATION,
            payload: response
        })
    } catch (e) {
        checkAuthorizationError(e, dispatch)
        result = {
            error: e.message
        }
    }
    return result;
}

export const fetchStoreMultistore = () => async (dispatch, getState, api) => {
    let result = {}
    try {
        const url = `api/v1/dashboard/estabelecimentos/multilojas`;
        const apiResponse = await api.get(url, {
            ...withAuthHeader()
        });
        result = {
            success: true,
            payload: mapFetchStoreMultistoreResponse(apiResponse.data)
        }
    } catch (e) {
        result = {
            error: e.message
        }
    }
    return result;
}
